module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('seller')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39128685!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/seller/demo.vue
// module id = 242
// module chunks = 2